import React from 'react';
import Particles from "react-tsparticles";


const Particle: React.FC = () => {
  return (
    <Particles
      id="particles"
      options={{
        background: {
          color: {
            value: "#1d232b",
          },
        },
        fpsLimit: 60,
        particles: {
          color: {
            value: "#ffffff",
          },
          links: {
            color: "#ffffff",
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 0.3,
          },
          collisions: {
            enable: false,
          },
          move: {
            direction: "none",
            enable: true,
            outMode: "out",
            random: false,
            speed: 2.5,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              value_area: 800,
            },
            value: 80,
            limit: 80
          },
          opacity: {
            value: 0.6,
            random: false,
            anim: {
              enable: true,
              speed: 1,
              opacity_min: 0,
              sync: false
            }
          },
          shape: {
            type: "circle",
          },
          size: {
            random: true,
            value: 3,
            anim: {
              enable: true,
              speed: 2,
              size_min: 0,
              sync: false
            }
          },
        },
        interactivity: {
          events: {
            resize: true
          }
        },
        detectRetina: true,
      }}
    />
  );
}

export default Particle;
